'use client'
import { useSession } from 'next-auth/react'
import React from 'react'

import { useTopbarCompanySwitcher } from '@maestro/commerce-blocks/components/header-topbar/batons/use-topbar-company-switcher'
import { Button } from '@pearlconvert/ui/components/button'

import '@maestro/commerce-blocks/components/header-topbar/styles/header-topbar.scss'

const HeaderTopbarCompanySwitcher = () => {
  const { data: session } = useSession()

  const { handleClickCompanySwitcher, isUserLoggedIn } =
    useTopbarCompanySwitcher()

  const company = session?.user?.company
  if (!company || !isUserLoggedIn) {
    return null
  }

  return (
    <Button
      type="link"
      iconRight="arrow-small-down"
      className="header-topbar__switcher"
      onClick={handleClickCompanySwitcher}
    >
      {company.name} - {company.id}
    </Button>
  )
}

export default HeaderTopbarCompanySwitcher
